/* Live open/closed status for every location on the page.
   Computed in America/Halifax so a visitor in another province sees the
   store's real status rather than their own local time. Hours come from the
   Location metaobject via data attributes, so staff edits take effect without
   a code change. */
(function () {
  function toMinutes(s) {
    var m = String(s || '').trim().match(/^(\d{1,2}):(\d{2})\s*(am|pm)?$/i);
    if (!m) return null;
    var h = parseInt(m[1], 10);
    var min = parseInt(m[2], 10);
    var ap = (m[3] || '').toLowerCase();
    if (ap === 'pm' && h !== 12) h += 12;
    if (ap === 'am' && h === 12) h = 0;
    return h * 60 + min;
  }

  function storeNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Halifax',
        weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false,
      }).formatToParts(new Date()).reduce(function (a, p) { a[p.type] = p.value; return a; }, {});
      return {
        weekend: parts.weekday === 'Sat' || parts.weekday === 'Sun',
        minutes: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10),
      };
    } catch (e) { return null; }
  }

  var now = storeNow();
  if (!now) return;

  document.querySelectorAll('[data-store-status]').forEach(function (el) {
    var openStr = el.getAttribute(now.weekend ? 'data-weekend-open' : 'data-weekday-open');
    var closeStr = el.getAttribute(now.weekend ? 'data-weekend-close' : 'data-weekday-close');
    var o = toMinutes(openStr);
    var c = toMinutes(closeStr);
    if (o === null || c === null) return;
    var isOpen = now.minutes >= o && now.minutes < c;
    var label = el.querySelector('[data-store-status-label]');
    if (label) label.textContent = isOpen ? 'Open now until ' + closeStr : 'Closed · opens ' + openStr;
    el.classList.toggle('lum-status--closed', !isOpen);
    el.hidden = false;
  });
})();
